/* eslint-disable array-callback-return */
/* eslint-disable radix */
/* eslint-disable no-undef */
import React from 'react';
import { observable, action } from 'mobx';
import { observer } from 'mobx-react';
import Utils from 'Utils/utils';
import { makeApi, URLS } from 'Utils/apiUtil';
import * as CONSTANTS from 'Utils/constants';
import { advSearchState } from 'Stores/advSearch';
import { LoadingWrapper } from '../loadingWrapper';
import { ReactComponent as CloseIcon } from '../../../../assets/svg/close-material.svg';
import userDetail from 'Stores/userDetail';

const { EXPORT_SOURCE, EXPORT_PAGE_SOURCE } = CONSTANTS;
const { ADVANCED_SEARCH, MY_LEADS } = EXPORT_SOURCE;
class OwnershipMappingState {
  @observable showPopup = false;

  @observable companyExport = false;

  @observable exportCallback;

  @observable cancelCallback;

  @observable exportType = 'Salesforce';

  @observable exportSource = '';

  // used only when enrichment flag enabled and as of now hubspot only
  @observable postData = {};

  @action
  setCompanyExport = val => {
    this.companyExport = val;
  };

  @action
  setExportCallback = val => {
    this.exportCallback = val;
  };

  @action
  setCancelCallback = val => {
    this.cancelCallback = val;
  };

  @action
  setShowPopup = val => {
    this.showPopup = val;
  };

  @action
  setExportType = val => {
    this.exportType = val;
  };

  @action
  setExportSource = val => {
    this.exportSource = val;
  };

  @action
  setPostData = data => {
    this.postData = data;
  };
}
const ownershipMappingState = new OwnershipMappingState();

const OwnershipMappingPopup = observer(props => {
  const [ownershipData, setOwnershipData] = React.useState({});
  const [ownerShipOriginalData, setOwnerShipOriginalData] = React.useState({});
  const [assignAll, setAssignAll] = React.useState(false);
  const [assignAllId, setAssignAllId] = React.useState('');
  const [assignAllUnAssigned, setAssignAllUnAssigned] = React.useState(false);
  const [assignAllUnAssignedId, setAssignAllUnAssignedId] = React.useState('');
  const [selectOwnerError, showSelectOwnerError] = React.useState('');
  const [hasAlreadyAssigned, setHasAlreadyAssigned] = React.useState(false);
  const [hasAlreadyNotAssigned, setHasAlreadyNotAssigned] = React.useState(
    false,
  );

  const { searchType = 'CONTACT' } = props;

  const [showSuggestion, setShowSuggestion] = React.useState(false);
  // Until this state is true, error message shown, anyhow API is made
  const [showLoading, setShowLoading] = React.useState(true);

  const closeSuggestion = e => {
    if (e !== null && e !== undefined) e.stopPropagation();

    const eleList = document.getElementsByClassName('dropdown-focused');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('dropdown-focused');
    setShowSuggestion(false);
  };

  const getOwnerName = (data, ownerId) => {
    if (ownerId !== undefined && ownerId !== null && ownerId !== '')
      if (data && data.users && data.users.length > 0) {
        let ownerName = '';
        data.users.map(item => {
          if (item.id === ownerId) ownerName = item.name;
        });
        return ownerName;
      }

    return '';
  };

  const chooseAssignAll = (e, id, name) => {
    console.log('val ', id, name);
    if (id === '' || name === '') {
      setAssignAllId('');
    } else {
      setAssignAllId({
        id,
        name,
      });
      const formattedData = JSON.parse(JSON.stringify(ownershipData));
      console.log(
        'formatOwnershipData original data',
        JSON.parse(JSON.stringify(ownershipData)),
      );
      let newAccounts;
      const ownerName = getOwnerName(formattedData, id);
      if (
        formattedData &&
        formattedData.accounts &&
        formattedData.accounts.length > 0
      ) {
        newAccounts = formattedData.accounts.map(item => {
          const newItem = item;

          if (!newItem.alreadyAssigned) {
            newItem.ownerName = ownerName;
            newItem.ownerId = id;
          }

          return newItem;
        });
        formattedData.accounts = newAccounts;
      }
      console.log('formatOwnershipData', formattedData);
      setOwnershipData(formattedData);
      setAssignAllUnAssignedId('');
    }
    setShowSuggestion(false);
    closeSuggestion();
  };

  const chooseAssignAllUnassigned = (e, id, name) => {
    console.log('val ', id, name);
    if (id === '' || name === '') {
      setAssignAllUnAssignedId('');
    } else {
      setAssignAllUnAssignedId({
        id,
        name,
      });

      const formattedData = JSON.parse(JSON.stringify(ownershipData));
      console.log(
        'formatOwnershipData original data',
        JSON.parse(JSON.stringify(ownershipData)),
      );
      let newAccounts;
      const ownerName = getOwnerName(formattedData, id);
      if (
        formattedData &&
        formattedData.accounts &&
        formattedData.accounts.length > 0
      ) {
        newAccounts = formattedData.accounts.map(item => {
          const newItem = item;

          if (newItem.ownerName === '' && !newItem.alreadyAssigned) {
            newItem.ownerName = ownerName;
            newItem.ownerId = id;
          }

          return newItem;
        });
        formattedData.accounts = newAccounts;
      }
      console.log('formatOwnershipData', formattedData);
      setOwnershipData(formattedData);
      setAssignAllId('');
    }
    setShowSuggestion(false);
    closeSuggestion();
  };

  const chooseOwnerSeperately = (e, accountDomain, id, name) => {
    const newFormattedData = ownershipData;

    if (
      newFormattedData &&
      newFormattedData.accounts &&
      newFormattedData.accounts.length > 0
    ) {
      const newAccounts = newFormattedData.accounts.map(item => {
        const newItem = item;
        if (accountDomain === item.domain) {
          newItem.ownerName = name;
          newItem.ownerId = id;
        }
        return newItem;
      });

      newFormattedData.accounts = newAccounts;
      console.log('chooseOwnerSeperately', newFormattedData);
      setOwnershipData(newFormattedData);
    }
    setShowSuggestion(false);
    closeSuggestion();
  };

  const confirmClick = () => {
    showSelectOwnerError('');
    console.log('ownershipData ownershipData ', ownershipData);
    const postData = {};

    if (ownershipData && ownershipData.accounts)
      ownershipData.accounts.map(item => {
        if (item.ownerId !== '') postData[item.domain] = item.ownerId;
      });
    console.log('postData ', postData);
    ownershipMappingState.exportCallback(postData);
    ownershipMappingState.setShowPopup(false);
  };

  const continueWithoutExport = () => {
    ownershipMappingState.cancelCallback();
    ownershipMappingState.setShowPopup(false);
  };

  const onDropDownClick = e => {
    if (!showSuggestion) setShowSuggestion(true);
    const eleList = document.getElementsByClassName('owners-suggestion');
    if (eleList !== undefined && eleList.length > 0)
      for (let i = 0; i < eleList.length; i += 1)
        eleList[i].classList.remove('dropdown-focused');
    e.currentTarget.parentElement.classList.add('dropdown-focused');
  };

  const formatOwnershipData = data => {
    const formattedData = JSON.parse(JSON.stringify(data));
    console.log(
      'formatOwnershipData original data',
      JSON.parse(JSON.stringify(data)),
    );
    let newAccounts = [];
    if (data && data.accounts && data.accounts.length > 0) {
      newAccounts = data.accounts.map(item => {
        const newItem = item;
        newItem.ownerName = getOwnerName(data, item.ownerId);
        if (newItem.ownerName !== '') {
          // console.log('item newItem if', JSON.parse(JSON.stringify(newItem)));
          // console.log('hasAlreadyAssigned ', hasAlreadyAssigned);
          newItem.alreadyAssigned = true;
          if (!hasAlreadyAssigned) setHasAlreadyAssigned(true);
        } else {
          // console.log('item newItem else', JSON.parse(JSON.stringify(newItem)));
          // console.log('hasAlreadyNotAssigned ', hasAlreadyNotAssigned);
          newItem.alreadyAssigned = false;
          if (!hasAlreadyNotAssigned) setHasAlreadyNotAssigned(true);
        }
        newItem.ownerId = '';
        return newItem;
      });
      formattedData.accounts = newAccounts;
    }
    console.log('formatOwnershipData', formattedData);
    setOwnershipData(formattedData);
  };

  const getOwnershipData = () => {
    let config = {};
    const {
      companyExport = false,
      exportType,
      exportSource,
      postData: exportPostData,
    } = ownershipMappingState;

    let postData = {};

    const { requestType } = exportPostData;

    if (exportSource === ADVANCED_SEARCH && !companyExport) {
      postData = advSearchState.getExportIdsPostData();
      postData.euContacts = userDetail.featureFlags.EU_CONTACTS;
    } else {
      postData = Utils.copyObjectWithoutReference(
        ownershipMappingState.postData,
      );
      postData.exportSource = exportSource;
    }

    const url = Utils.generateUrl(URLS?.crmExport?.accountOwnershipMapping, {
      crmType: exportType.toUpperCase(),
      type: requestType,
      source:
        exportSource === ADVANCED_SEARCH
          ? EXPORT_PAGE_SOURCE.ADVANCED_SEARCH
          : EXPORT_PAGE_SOURCE.MY_LEADS,
    });

    config = {
      url,
      method: 'POST',
      data: postData,
    };

    setShowLoading(true);
    makeApi(config)
      .then(response => {
        if (response && response.data) {
          const { responseCode = '', responseData } = response.data;
          if (responseCode === 200) {
            setOwnerShipOriginalData(JSON.parse(JSON.stringify(responseData)));
            formatOwnershipData(responseData);
          }
        }
        setShowLoading(false);
      })
      .catch(error => {
        console.log('setOwnershipData error ', error);
      });
  };

  const accountAndOwnerMapping = (showAassigned = false) => {
    const userIds =
      ownershipData && ownershipData.users && ownershipData.users.length > 0
        ? ownershipData.users.map(item => {
            return item.id;
          })
        : [];
    return (
      <div className="seperate-map-wrapper-list">
        {ownershipData.accounts &&
          ownershipData.accounts.length > 0 &&
          ownershipData.accounts.map((accountItem, accountIndex) => {
            if (showAassigned)
              return accountItem.alreadyAssigned === true &&
                accountItem.domain !== '' &&
                accountItem.domain !== null ? (
                <div className="account-item" key={`accountMap${accountIndex}`}>
                  <div className="account-name">{accountItem.name}</div>
                  <div className="account-owner">{accountItem.ownerName}</div>
                  <div className="account-contacts">
                    {accountItem.contactsCount}
                  </div>
                </div>
              ) : (
                ''
              );

            return accountItem.alreadyAssigned === false &&
              accountItem.domain !== '' &&
              accountItem.domain !== null ? (
              <div className="account-item" key={`accountMap${accountIndex}`}>
                <div className="account-name">{accountItem.name}</div>
                <div className="account-owner">
                  <div className="dropdown-section owners-suggestion">
                    <div className="dropdown-box" onClick={onDropDownClick}>
                      <span>
                        {accountItem.ownerName !== ''
                          ? accountItem.ownerName
                          : 'Select From Dropdown'}
                      </span>
                      <i
                        className="fa fa-angle-down dropdown-icon"
                        aria-hidden="true"
                      />
                    </div>

                    <div className="suggestion-list hide-suggestion">
                      <div className="suggestion-list-wrap">
                        <div
                          className="suggestion-item"
                          onClick={e =>
                            chooseOwnerSeperately(e, accountItem.domain, '', '')
                          }
                        >
                          None
                        </div>
                        {ownershipData.users &&
                          ownershipData.users.map((item, index) => {
                            return (
                              <div
                                key={`seqList${index}`}
                                className="suggestion-item"
                                data-name={item.name}
                                onClick={e =>
                                  chooseOwnerSeperately(
                                    e,
                                    accountItem.domain,
                                    item.id,
                                    item.name,
                                  )
                                }
                              >
                                {item.name}
                              </div>
                            );
                          })}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="account-contacts">
                  {accountItem.contactsCount}
                </div>
              </div>
            ) : (
              ''
            );
          })}
      </div>
    );
  };
  const resetToDefault = e => {
    if (e !== undefined && e !== null) e.preventDefault();
    formatOwnershipData(JSON.parse(JSON.stringify(ownerShipOriginalData)));
    setAssignAllId('');
    setAssignAllUnAssignedId('');
  };

  React.useEffect(() => {
    if (ownershipMappingState.showPopup) {
      setAssignAll(false);
      setAssignAllId('');
      setAssignAllUnAssigned(false);
      setAssignAllUnAssignedId('');
      showSelectOwnerError('');
      setOwnershipData({});
      setOwnerShipOriginalData({});
      setHasAlreadyAssigned(false);
      setHasAlreadyNotAssigned(false);
      getOwnershipData();
    } else {
      setAssignAll(false);
      setAssignAllId('');
      setAssignAllUnAssigned(false);
      setAssignAllUnAssignedId('');
      showSelectOwnerError('');
      setOwnershipData({});
      setOwnerShipOriginalData({});
      setHasAlreadyAssigned(false);
      setHasAlreadyNotAssigned(false);
      setShowLoading(true);
    }
  }, [ownershipMappingState.showPopup]);

  return ownershipMappingState.showPopup ? (
    <>
      <div
        className={`export-type-popup ownership-popup common-popup ${
          searchType === 'COMPANY' ? 'company-ownership-popup' : ''
        }`}
      >
        <div className="popup-wrap">
          <div
            className="popup-close"
            title="Click here to close"
            onClick={() => ownershipMappingState.setShowPopup(false)}
          >
            <CloseIcon />
          </div>
          <LoadingWrapper show={showLoading} />
          <div className="title">
            Assign Owners
            {hasAlreadyNotAssigned && (
              <div
                className="reset-all-to-default"
                onClick={e => resetToDefault(e)}
              >
                reset
              </div>
            )}
          </div>

          <div className="popup-content-wrap">
            {showSuggestion && (
              <div
                className="owners-suggestion-mask"
                onClick={closeSuggestion}
              />
            )}
            {!showLoading && (
              <>
                <div className="export-sequence-wrap">
                  {hasAlreadyNotAssigned && (
                    <>
                      <div className="assign-all unassigned">
                        <div className="assign-text-wrap input-section check-box-wrap">
                          <div className="title-checkbox">
                            <span className="check-box-label">
                              Assign all unassigned{' '}
                              {ownershipMappingState.exportType === 'Salesforce'
                                ? 'accounts'
                                : 'companies'}{' '}
                              to
                            </span>
                          </div>
                        </div>
                        <div className="dropdown-section owners-suggestion">
                          <div
                            className="dropdown-box"
                            onClick={onDropDownClick}
                          >
                            <span>
                              {assignAllUnAssignedId !== ''
                                ? assignAllUnAssignedId.name
                                : 'Select From Dropdown'}
                            </span>
                            <i
                              className="fa fa-angle-down dropdown-icon"
                              aria-hidden="true"
                            />
                          </div>

                          <div className="suggestion-list hide-suggestion">
                            <div className="suggestion-list-wrap">
                              {/* <div
                                className="suggestion-item"
                                onClick={e => chooseAssignAllUnassigned(e, '', '')}
                              >
                                None
                              </div> */}
                              {ownershipData.users &&
                                ownershipData.users.map((item, index) => {
                                  return (
                                    <div
                                      key={`seqList${index}`}
                                      className="suggestion-item"
                                      data-name={item.name}
                                      onClick={e =>
                                        chooseAssignAllUnassigned(
                                          e,
                                          item.id,
                                          item.name,
                                        )
                                      }
                                    >
                                      {item.name}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="assign-all">
                        <div className="assign-text-wrap input-section check-box-wrap">
                          <div className="title-checkbox">
                            <span className="check-box-label">
                              Assign all{' '}
                              {ownershipMappingState.exportType === 'Salesforce'
                                ? 'accounts'
                                : 'companies'}{' '}
                              to
                            </span>
                          </div>
                        </div>
                        <div className="dropdown-section owners-suggestion">
                          <div
                            className="dropdown-box"
                            onClick={onDropDownClick}
                          >
                            <span>
                              {assignAllId !== ''
                                ? assignAllId.name
                                : 'Select From Dropdown'}
                            </span>
                            <i
                              className="fa fa-angle-down dropdown-icon"
                              aria-hidden="true"
                            />
                          </div>

                          <div className="suggestion-list hide-suggestion">
                            <div className="suggestion-list-wrap">
                              {/* <div
                                className="suggestion-item"
                                onClick={e => chooseAssignAll(e, '', '')}
                              >
                                None
                              </div> */}
                              {ownershipData.users &&
                                ownershipData.users.map((item, index) => {
                                  return (
                                    <div
                                      key={`seqList${index}`}
                                      className="suggestion-item"
                                      data-name={item.name}
                                      onClick={e =>
                                        chooseAssignAll(e, item.id, item.name)
                                      }
                                    >
                                      {item.name}
                                    </div>
                                  );
                                })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  {hasAlreadyNotAssigned && (
                    <div className="account-owner-seperate-map">
                      <div className="seperate-map-header">
                        <div className="header-item">
                          {ownershipMappingState.exportType === 'Salesforce'
                            ? 'Account'
                            : 'Company'}
                        </div>
                        <div className="header-item">Owner</div>
                        <div className="header-item contacts-count">
                          No.of Contacts
                        </div>
                      </div>
                      {accountAndOwnerMapping()}
                    </div>
                  )}
                  {!hasAlreadyAssigned && !hasAlreadyNotAssigned && (
                    <div className="all-account-already-assigned-title">
                      Unable to retrieve{' '}
                      <span className="span-mr">
                        {ownershipMappingState.exportType === 'Salesforce'
                          ? 'account'
                          : 'company'}
                      </span>
                      details from your CRM. You can try exporting without
                      assigning owners.
                      <br /> <br />
                      Please contact{' '}
                      <a
                        href="mailto:support@adapt.io"
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        support@adapt.io
                      </a>{' '}
                      if this issue persists.
                    </div>
                  )}
                  {hasAlreadyAssigned && (
                    <>
                      {hasAlreadyNotAssigned ? (
                        <div className="account-already-assigned-title">
                          {ownershipMappingState.exportType === 'Salesforce'
                            ? 'Accounts'
                            : 'Companies'}{' '}
                          with owners already assigned in your CRM
                        </div>
                      ) : (
                        <div className="all-account-already-assigned-title">
                          All{' '}
                          {ownershipMappingState.exportType === 'Salesforce'
                            ? 'accounts'
                            : 'companies'}{' '}
                          already have owners assigned in your CRM
                        </div>
                      )}
                      <div className="account-owner-seperate-map">
                        <div className="seperate-map-header">
                          <div className="header-item">
                            {ownershipMappingState.exportType === 'Salesforce'
                              ? 'Account'
                              : 'Company'}
                          </div>
                          <div className="header-item">Owner</div>
                          <div className="header-item contacts-count">
                            No.of Contacts
                          </div>
                        </div>
                        {accountAndOwnerMapping(true)}
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="popup-action-wrap">
            {hasAlreadyNotAssigned && (
              <div className="popup-action-btn" onClick={continueWithoutExport}>
                Continue without Assigning Owners
              </div>
            )}
            <div
              className="popup-action-btn positive-btn"
              onClick={confirmClick}
            >
              Export
            </div>
          </div>

          {/* {showSuggestion && (
            <div className="owners-suggestion-mask" onClick={closeSuggestion} />
          )} */}
        </div>
      </div>
      <div
        className="common-popup-mask"
        onClick={() => ownershipMappingState.setShowPopup(false)}
      />
    </>
  ) : (
    ''
  );
});

export { OwnershipMappingPopup, ownershipMappingState };
export default OwnershipMappingPopup;
